import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        border: `0.5px solid ${isHosTheme ? theme.palette.secondary.dark : theme.palette.grey[600]}`,
        borderRadius: '10px',
        cursor: 'pointer',
        padding: '25px 20px',
        textAlign: 'left',
        rowGap: isHosTheme ? '8px' : '5px',
        boxSizing: 'border-box',
    }),
};
